var _path, _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17.009,
    viewBox: "0 0 17 17.009",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_37541",
    "data-name": "Path 37541",
    d: "M9,5.25A3.75,3.75,0,1,1,5.24,8.96,3.747,3.747,0,0,1,9,5.25Zm2.24,3.74a2.245,2.245,0,1,0-2.21,2.26A2.258,2.258,0,0,0,11.24,8.99Z",
    transform: "translate(-0.49 -0.491)",
    fill: "#b1aeae"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_159979",
    "data-name": "Group 159979",
    transform: "translate(0 7.744)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37542",
    "data-name": "Path 37542",
    d: "M1.91,8.25c.36,0,.72-.01,1.08,0A.745.745,0,1,1,3,9.74q-1.125.03-2.25,0A.728.728,0,0,1,0,9a.74.74,0,0,1,.74-.75C1.13,8.23,1.52,8.25,1.91,8.25Z",
    transform: "translate(0 -8.235)",
    fill: "#b1aeae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37543",
    "data-name": "Path 37543",
    d: "M16.1,9.75c-.36,0-.72.01-1.08,0a.75.75,0,1,1-.01-1.5c.73-.02,1.47-.02,2.2,0a.727.727,0,0,1,.77.76.756.756,0,0,1-.77.73H16.09Z",
    transform: "translate(-0.981 -8.235)",
    fill: "#b1aeae"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_159980",
    "data-name": "Group 159980",
    transform: "translate(2.455 2.379)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37544",
    "data-name": "Path 37544",
    d: "M4.56,3.43c.25.26.51.5.75.77A.742.742,0,0,1,4.26,5.25c-.54-.52-1.07-1.06-1.58-1.6a.724.724,0,0,1,0-1.05.733.733,0,0,1,1.05,0c.29.26.55.55.83.83Z",
    transform: "translate(-2.455 -2.379)",
    fill: "#b1aeae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37545",
    "data-name": "Path 37545",
    d: "M13.45,14.59c-.25-.26-.51-.5-.75-.77a.746.746,0,0,1,0-1.09.726.726,0,0,1,1.05.04c.53.51,1.04,1.04,1.55,1.57a.746.746,0,0,1,0,1.09.765.765,0,0,1-1.06-.03l-.07-.07c-.24-.24-.48-.49-.72-.73Z",
    transform: "translate(-3.436 -3.36)",
    fill: "#b1aeae"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_159981",
    "data-name": "Group 159981",
    transform: "translate(7.754)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37546",
    "data-name": "Path 37546",
    d: "M8.25,1.87V.79A.747.747,0,1,1,9.74.8q.015,1.08,0,2.16a.741.741,0,0,1-.75.79.754.754,0,0,1-.74-.8V1.88Z",
    transform: "translate(-8.245)",
    fill: "#b1aeae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37547",
    "data-name": "Path 37547",
    d: "M9.75,16.12c0,.37.01.75,0,1.12a.745.745,0,1,1-1.49.01q-.03-1.125,0-2.25A.728.728,0,0,1,9,14.25a.74.74,0,0,1,.75.74c.02.37,0,.75,0,1.12Z",
    transform: "translate(-8.245 -0.981)",
    fill: "#b1aeae"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_159982",
    "data-name": "Group 159982",
    transform: "translate(2.405 2.409)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37548",
    "data-name": "Path 37548",
    d: "M13.51,3.42c.25-.25.5-.52.76-.76a.748.748,0,1,1,1.05,1.06c-.5.52-1.01,1.03-1.52,1.53a.748.748,0,0,1-1.09.03.757.757,0,0,1,.04-1.09l.07-.07.7-.7Z",
    transform: "translate(-3.386 -2.409)",
    fill: "#b1aeae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37549",
    "data-name": "Path 37549",
    d: "M4.49,14.57c-.26.27-.52.54-.8.79a.745.745,0,0,1-1.06,0,.725.725,0,0,1,0-1.05q.78-.81,1.59-1.59a.717.717,0,0,1,1.05,0,.733.733,0,0,1,0,1.05c-.25.28-.53.53-.79.8Z",
    transform: "translate(-2.405 -3.39)",
    fill: "#b1aeae"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/Sun.b445393ac34410ae6f8f56c400a19780.svg";
export { ForwardRef as ReactComponent };